import { IAuthState } from 'containers/Auth'
import * as firebase from 'firebase/app'
import { IClient } from 'interfaces/IClient'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { nameof } from 'utils'

class ClientEditor extends React.Component<
  RouteComponentProps<{ id: string }> & { company: IAuthState['company'] },
  { client: IClient }
> {
  public state = {
    client: {
      name: '',
      adress: '',
      city: '',
      reference: '',
      zip: '',
    },
  }

  public async componentDidMount() {
    const { currentUser } = firebase.auth()
    const { props } = this

    if (props.match.params.id && currentUser) {
      const snapshot = await firebase
        .database()
        .ref(
          `/clients/${currentUser.uid}/${props.company}/${props.match.params.id}`
        )
        .once('value')

      this.setState({ client: snapshot.val() })
    }
  }

  public handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const { currentUser } = firebase.auth()
    const { props, state } = this
    const { id } = props.match.params

    if (!currentUser) {
      throw new Error('No UID')
    }

    if (id) {
      firebase
        .database()
        .ref(`/clients/${currentUser.uid}/${props.company}/${id}`)
        .set(state.client)
        .then(() => props.history.push('/clients'))
    } else {
      firebase
        .database()
        .ref(`/clients/${currentUser.uid}/${props.company}/`)
        .push(state.client)
        .then(() => props.history.push('/clients'))
    }
  }

  public handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.currentTarget

    this.setState({ client: { ...this.state.client, [name]: value } })
  }

  public render() {
    const { props, state } = this

    return (
      <form onSubmit={this.handleSubmit}>
        <h3>Företag</h3>
        <input
          type="text"
          name={nameof<IClient>('name')}
          style={{ fontSize: 14 }}
          value={state.client.name}
          onChange={this.handleChange}
          required
        />
        <div className="spacer" />

        <h3>Referens</h3>
        <input
          type="text"
          name={nameof<IClient>('reference')}
          value={state.client.reference}
          onChange={this.handleChange}
        />
        <div className="spacer" />

        <h3>Adress</h3>
        <input
          type="text"
          name={nameof<IClient>('adress')}
          value={state.client.adress}
          onChange={this.handleChange}
          required
        />
        <div className="spacer" />

        <table className="clean">
          <tbody>
            <tr>
              <td>
                <h3>Postnummer</h3>
              </td>
              <td>
                <h3>Ort</h3>
              </td>
            </tr>
            <tr>
              <td>
                <input
                  type="text"
                  name={nameof<IClient>('zip')}
                  style={{ width: 100 }}
                  value={state.client.zip}
                  onChange={this.handleChange}
                  required
                />
              </td>
              <td>
                <input
                  type="text"
                  name={nameof<IClient>('city')}
                  style={{ width: 460 }}
                  value={state.client.city}
                  onChange={this.handleChange}
                  required
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div className="submit">
          <button className="button">
            <span>{props.match.params.id ? 'Uppdatera' : 'Lägg till'}</span>
          </button>
        </div>
      </form>
    )
  }
}

export default ClientEditor



// WEBPACK FOOTER //
// ./src/components/ClientEditor/ClientEditor.tsx